import React, { useState, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import colors from "../Constant/colors.js";
import LoadingButton from "./LoadingButton.jsx";
const ExamDateSheet = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [examDetails, setExamDetails] = useState([]);
  const [allExams, setAllExams] = useState([]);
  const [teacher, setTeacher] = useState([]);
  const [selectedSession, setSelectedSession] = useState(""); // Session state
const [teacherOptions, setTeacherOptions] = useState([]);
 const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const label18 = "block text-black font-semibold text-[18px] mb-1 text-left";

  const inputStyle = {
    border: "1px solid #1E40AF",
    padding: "10px",
    borderRadius: "8px",
    width: "100%",
    fontSize: "14px",
    background: "white",
  };

  const buttonStyle = {
    background: colors.gradientPrimary,
    color: "white",
    padding: "12px 22px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "18px",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  };

  // LOAD INITIAL DATA
  useEffect(() => {
    // Get session ID from localStorage
    
    const sessionIdFromLocalStorage = localStorage.getItem("currentSessionId");
    console.log(localStorage.getItem("currentSessionId"));

    if (!sessionIdFromLocalStorage) {
      alert("Session ID is missing. Please log in again.");
      navigate("/login");
      return;
    }

    setSelectedSession(sessionIdFromLocalStorage);

    // Fetch classes based on the selected session
    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/classes/getClasses?sessionId=${sessionIdFromLocalStorage}`)
      .then((res) => {
        setClasses(res.data);
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
        alert("Error fetching classes. Please try again.");
      });

    // Fetch other data
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/exams/getExams/${sessionIdFromLocalStorage}`,
    ).then((res) => setAllExams(res.data));
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers`, 
       { params: { sessionId: sessionIdFromLocalStorage } }
    )
.then(response => {
   console.log("Teachers response:", response.data);
   const teachersArray = Array.isArray(response.data) ? response.data : [response.data];

    // Convert to react-select format
    const options = teachersArray.map((teacher) => ({
      value: teacher._id,
      label: `${teacher.firstName} ${teacher.lastName}`,
    }));

    setTeacherOptions(options);
})
.catch(err => console.error(err));

  }, []); // Empty dependency array to run once on mount

  // HANDLE CLASS CHANGE
  const handleClassChange = (selectedOption) => {
    setSelectedClass(selectedOption);

    if (!selectedOption) return;

    axios
      .get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/subjects/getSubjectsByClassName/${selectedOption.value}`,
        { params: { sessionId: selectedSession } }
      )
      .then((res) => {
        setSubjects(res.data);

        const initial = res.data.map((sub) => ({
          subjectName: sub.subjectName,
          examDate: "",
          startTime: "",
          endTime: "",
          invigilator: "",
          notes: "",
          room: "",
        }));

        setExamDetails(initial);
      })
      .catch((err) => {
        console.error("Error fetching subjects:", err.response ? err.response.data : err.message);
        alert("Error fetching subjects. Please try again.");
      });
  };


  // UPDATE INPUT VALUES
  const handleInputChange = (index, field, value) => {
    const updated = [...examDetails];
    updated[index] = { ...updated[index], [field]: value };
    setExamDetails(updated);
  };

  // SUBMIT FORM
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const examName = e.target.examName.value;
    if (!examName) {
      alert("Please provide an exam name.");
      return;
    }
    // Check if all fields are filled
    // Only keep subjects where at least one field is filled
const filledSubjects = examDetails.filter(
  (detail) =>
    detail.examDate ||
    detail.startTime ||
    detail.endTime ||
    detail.invigilator ||
    detail.room
);

if (filledSubjects.length === 0) {
  alert("Please fill details for at least one subject.");
  return;
}

    const data = {
  examName: e.target.examName.value,
  class: selectedClass.value,
  subjects: filledSubjects,
  sessionId: selectedSession,
};

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/api/exams/createExam`, data,
        {
          headers:{ Authorization: `Bearer ${localStorage.getItem("token")}` }
        }
      )
      .then(() => {
        alert("Exam datesheet created successfully");
        setSelectedClass(null);
      setSubjects([]);
      setExamDetails([]);
      e.target.reset();

        // Fetch the latest exams
        axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/exams/getExams/${selectedSession}`)
          .then((res) => setAllExams(res.data))
      })
      .catch((err) => {
        console.error("Error creating exam:", err);
        alert("Error creating exam. Please try again.");
      }
      ).finally(() => setLoading(false)   );
  };

  // DELETE EXAM
  const handleDelete = (id) => {
    if (!window.confirm("Delete this exam?")) return;

    axios.delete(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/exams/deleteExam/${id}`,
      { params: { sessionId: selectedSession },
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      
    )
      .then(() => {
        setAllExams(allExams.filter((exam) => exam._id !== id));
      }).catch((err) => {
        console.error("Error deleting exam:", err);
        alert("Error deleting exam. Please try again.");
      });
  };

  return (
    <div className="min-h-screen p-6 bg-white text-left">
      {/* ★ MAIN WRAPPER FULL WIDTH (MATCHES SIDEBAR ALIGNMENT) */}
      <div className="flex-1 w-full pl-10 pr-6 text-left">
        {/* TITLE */}
        <h2
          className="font-bold mb-10 text-left"
          style={{ color: colors.primary, fontSize: "18px" }}
        >
          Create Exam Datesheet
        </h2>

        {/* CLASS SELECTOR */}
        <div className="mb-6 text-left">
          <label className={label18}>Select Class:</label>
          <Select
            options={classes.map((c) => ({
              value: c.className,
              label: c.className,
            }))}
            onChange={handleClassChange}
            placeholder="Select class"
            styles={{
              control: (base) => ({
                ...base,
                fontSize: "14px",
                textAlign: "left",
              }),
            }}
          />
        </div>

        {/* FORM */}
        {selectedClass && (
          <form className="grid grid-cols-1 gap-6 text-left" onSubmit={handleSubmit}>
            <div>
              <label className={label18}>Exam Name:</label>
              <input
                name="examName"
                placeholder="Enter exam name"
                style={inputStyle}
                required
              />
            </div>

            {subjects.map((subject, index) => (
              <div
                key={subject._id}
                className="p-4 rounded-lg shadow-md text-left"
                style={{ background: colors.grayLight }}
              >
                <h3 className="font-semibold text-[18px] mb-3 text-black">
                  {subject.subjectName}
                </h3>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-left">
                  <input
                    type="date"
                    style={inputStyle}
                    value={examDetails[index]?.examDate || ""}
                    onChange={(e) =>
                      handleInputChange(index, "examDate", e.target.value)
                    }
                  />

                  <input
                    placeholder="Start Time"
                    style={inputStyle}
                    value={examDetails[index]?.startTime || ""}
                    onChange={(e) =>
                      handleInputChange(index, "startTime", e.target.value)
                    }
                  />

                  <input
                    placeholder="End Time"
                    style={inputStyle}
                    value={examDetails[index]?.endTime || ""}
                    onChange={(e) =>
                      handleInputChange(index, "endTime", e.target.value)
                    }
                  />

                  <div>
                    <label className="text-[18px] font-semibold text-black mb-1 block">
  Invigilator
</label>
<Select
  options={teacherOptions} // from backend
  value={teacherOptions.find(
    (opt) => opt.value === examDetails[index]?.invigilator
  )}
  onChange={(opt) =>
    handleInputChange(index, "invigilator", opt ? opt.value : "")
  }
  styles={{
    control: (base) => ({
      ...base,
      fontSize: "14px",
      textAlign: "left",
    }),
  }}
/>

                  </div>

                  <input
                    placeholder="Room Number"
                    style={inputStyle}
                    value={examDetails[index]?.room || ""}
                    onChange={(e) =>
                      handleInputChange(index, "room", e.target.value)
                    }
                  />

                  <textarea
                    placeholder="Notes"
                    style={{ ...inputStyle, height: "80px" }}
                    value={examDetails[index]?.notes || ""}
                    onChange={(e) =>
                      handleInputChange(index, "notes", e.target.value)
                    }
                  ></textarea>
                </div>
              </div>
            ))}

            <div className="flex justify-start mt-4">
            <button
  type="submit"
  style={{
    ...buttonStyle,
    backgroundColor: loading ? "#9ca3af" : buttonStyle.backgroundColor,
    cursor: loading ? "not-allowed" : "pointer",
    opacity: loading ? 0.8 : 1,
  }}
  disabled={loading}
>
  {loading ? "Please wait..." : "Create Exam Datesheet"}
</button>

            </div>
          </form>
        )}

        {/* EXAM LIST */}
        <div className="mt-10 text-left">
          

          <h3
            className="text-[18px] font-bold mb-4"
            style={{ color: colors.primary }}
          >
            All Created Exams
          </h3>

          {allExams.length > 0 ? (
            <ul className="space-y-4">
              {allExams.map((exam) => (
                <li
                  key={exam._id}
                  className="p-4 rounded-lg shadow-md flex justify-start items-center gap-6"
                  style={{ background: colors.grayLight }}
                >
                  <span className="text-[18px] font-semibold text-black">
                    {exam.class} — {exam.examName}
                  </span>

                  <div className="flex gap-3">
                    <button
                      onClick={() =>
                        navigate(`/view-datesheet/${exam._id}`, { state: { exam } })
                      }
                      className="px-4 py-2 rounded text-white"
                      style={{ background: colors.primary, fontSize: "18px" }}
                    >
                      View
                    </button>

                    <button
                      onClick={() => handleDelete(exam._id)}
                      className="px-4 py-2 rounded text-white"
                      style={{ background: "#DC2626", fontSize: "18px" }}
                    >
                      Delete
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No exams found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExamDateSheet;